import {
  AthleticsIcon,
  BaseballIcon,
  GolfIcon,
} from "pages/internal-dashboard/icons";

export const deviceTypesArray = ["All", "Android", "IOS", "Desktop"];
export const swingTypesArray = [
  "All",
  "Full Swing",
  "Short Game",
  "Putting",
  "Bunker",
  "Scan",
];

export const orientationTypesArray = [
  "All",
  "Face On",
  "Down The Line",
  "Both",
];

export const categoryTypesArray = [
  "All",
  "My Swings",
  "Community Swings",
  "Public Swings",
];

export const clubTypesArray = ["All", "Iron", "Driver", "Wedge"];
export const poseStatusTypesArray = ["All", "done", "error"];
export const clubStatusTypesArray = ["All", "done", "error"];
export const launchDataStatusTypesArray = ["All", "done", "error"];

export const dropDownTitle = {
  device: "device",
  orientation: "orientation",
  category: "category",
  swing: "swing",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  launchDataStatus: "launchDataStatus",
  processingTime: "processingTime",
};

export const initialValues = {
  swing: swingTypesArray[0],
  orientation: orientationTypesArray[0],
  poseStatus: poseStatusTypesArray[0],
  clubStatus: clubStatusTypesArray[0],
  launchDataStatus: launchDataStatusTypesArray[0],
  device: deviceTypesArray[0],
  to: null,
  from: null,
  timeInterval: "All",
  processingTime: [0, 3000],
};

export const initialModalValues = {
  timeInterval: "All",
  poseServerStatus: "All",
  clubServerStatus: "All",
  swing: "All",
  handedness: "All",
  orientation: "All",
  club: "All",
  role: "All",
  trigger: "All",
  device: "All",
  camera: "All",
  deviceAngle: "All",
  resolution: "All",
  isCameraMoved: "All",
  minProcessingTime: 0,
  maxProcessingTime: 0,
  iso: 0,
  shutter: 0,
  duration: 0,
  frameRate: 0,
};

export const queryParamsValues = {
  swing: "swing",
  orientation: "orientation",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  device: "device",
  to: "to",
  from: "from",
  timeInterval: "timeInterval",
  processingTime: "processingTime",
  launchDataStatus: "launchDataStatus",
};

export const deviceTypesLabels = {
  dc1: "DES",
  iOS: "IOS",
  and: "AND",
};

export const defaultValue = "All";
export const defaultValueProcessingTime = [0, 3000];
export const dateDropDownValues = [
  "Today",
  "Yesterday",
  "Last 7 days",
  "Last 30 Days",
  "All",
];

export const dropDownDateObject = {
  [dateDropDownValues[0]]: "today",
  [dateDropDownValues[1]]: "yesterday",
  [dateDropDownValues[2]]: "week",
  [dateDropDownValues[3]]: "month",
  [dateDropDownValues[4]]: "all",
};

const today = new Date();
const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));

export const dateObject = {
  today: {
    from: today,
    to: today,
  },
  yesterday: {
    from: yesterday,
    to: yesterday,
  },
  week: {
    from: new Date(new Date().setDate(new Date().getDate() - 8)),
    to: yesterday,
  },
  month: {
    from: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    to: yesterday,
  },

  all: {
    from: null,
    to: null,
  },
};

export const QUERY_PARAMS_OBJ: any = {
  swing: "swingType",
  orientation: "orientationType",
  poseStatus: "poseStatus",
  clubStatus: "clubStatus",
  device: "deviceType",
  to: "endDate",
  from: "startDate",
  timeInterval: "timeInterval",
  processingTime: "processingTime",
  launchDataStatus: "launchDataStatus",
};

export const swingTypes = {
  "Full Swing": "Full Swing",
  "Short Game": "Short Game",
  Putting: "Putting",
  Bunker: "Bunker",
};

export const QUERY_OPT_TYPE = {
  delete: "remove",
};

export const handednessObj: { [key: string]: string } = {
  leftHanded: "Left Handed",
  rightHanded: "Right Handed",
  left_handed: "Left Handed",
  right_handed: "Right Handed",
};

export const triggerTypeObj: { [key: string]: string } = {
  "Manual Recording": "Manaul Ball Trigger",
  "Auto Recording": "Auto Ball Trigger",
  manual: "Manaul Ball Trigger",
  auto: "Auto Ball Trigger",
};

export const sportTabsArr = [
  {
    icon: GolfIcon,
    label: "Golf",
    key: "golf",
  },
  {
    icon: BaseballIcon,
    label: "Baseball",
    key: "baseball",
  },
  {
    icon: AthleticsIcon,
    label: "Athletics",
    key: "athletics",
  },
];
